/**
 * Admin / Delivery Head console walkthrough.
 * Steps inherit nav visibility (including dhRestricted exclusions).
 * @module features/walkthrough/tours/adminTour
 */

import { hasAdminLikeAccess } from '../../../utils/userAccess';
import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep } from './navTourHelpers';

const meta = tourMeta('admin-console');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const ADMIN_TOUR = {
  id: 'admin-console',
  title: meta.title,
  description: meta.description,
  roles: ['admin', 'dh'],
  prerequisiteRoute: navItemPath('admin-dashboard') ?? '/admin/dashboard',
  priority: 20,
  version: 2,
  visible: (user) => hasAdminLikeAccess(user),
  steps: [
    navStep('admin-dashboard', {
      title: t('walkthrough.admin.dashboard.title'),
      body: t('walkthrough.admin.dashboard.body'),
    }),
    navStep('admin-notifications', {
      title: t('walkthrough.admin.notifications.title'),
      body: t('walkthrough.admin.notifications.body'),
    }),
    navStep('reporting-managers', {
      title: t('walkthrough.admin.reportingManagers.title'),
      body: t('walkthrough.admin.reportingManagers.body'),
    }),
    navStep('admin-clients', {
      title: t('walkthrough.admin.clients.title'),
      body: t('walkthrough.admin.clients.body'),
    }),
    navStep('admin-project-managers', {
      title: t('walkthrough.admin.projectManagers.title'),
      body: t('walkthrough.admin.projectManagers.body'),
    }),
    navStep('admin-projects', {
      title: t('walkthrough.admin.projects.title'),
      body: t('walkthrough.admin.projects.body'),
    }),
    navStep('admin-admins', {
      title: t('walkthrough.admin.administrators.title'),
      body: t('walkthrough.admin.administrators.body'),
    }),
    navStep('admin-configuration', {
      title: t('walkthrough.admin.configuration.title'),
      body: t('walkthrough.admin.configuration.body'),
    }),
    navStep('admin-employee-hours', {
      title: t('walkthrough.admin.employeeHours.title'),
      body: t('walkthrough.admin.employeeHours.body'),
    }),
    navStep('admin-project-hours', {
      title: t('walkthrough.admin.projectHours.title'),
      body: t('walkthrough.admin.projectHours.body'),
    }),
    navStep('all-employee-report', {
      title: t('walkthrough.admin.allEmployeeReport.title'),
      body: t('walkthrough.admin.allEmployeeReport.body'),
    }),
    navStep('admin-download-timesheet', {
      title: t('walkthrough.admin.download.title'),
      body: t('walkthrough.admin.download.body'),
    }),
  ],
};
